import { useTranslation } from "react-i18next";
import { Clock, Zap, PenOff, Database } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const benefits = [
  {
    icon: Clock,
    titleKey: "benefits.time.title",
    descKey: "benefits.time.desc",
    title: "Gagnez du temps",
    description:
      "Plus besoin de chercher les historiques ou de remplir des formulaires papier.",
    stat: "−70%",
    statLabelKey: "benefits.time.stat",
    statLabel: "temps de traitement",
  },
  {
    icon: Zap,
    titleKey: "benefits.planning.title",
    descKey: "benefits.planning.desc",
    title: "Interventions mieux planifiées",
    description:
      "Le moteur de planification prend en compte les disponibilités réelles.",
    stat: "2.4×",
    statLabelKey: "benefits.planning.stat",
    statLabel: "plus d'interventions/jour",
  },
  {
    icon: PenOff,
    titleKey: "benefits.paperless.title",
    descKey: "benefits.paperless.desc",
    title: "Zéro papier, zéro perte",
    description:
      "Les formulaires dynamiques remplacent les carnets et feuilles papier.",
    stat: "0",
    statLabelKey: "benefits.paperless.stat",
    statLabel: "document papier",
  },
  {
    icon: Database,
    titleKey: "benefits.data.title",
    descKey: "benefits.data.desc",
    title: "Données centralisées",
    description:
      "Historique complet, rapports PDF et filtrage avancé dans un seul espace.",
    stat: "100%",
    statLabelKey: "benefits.data.stat",
    statLabel: "de traçabilité",
  },
];

const BenefitsSection = () => {
  const { t } = useTranslation();

  return (
    <section className="assist-section assist-section-alt">
      <div className="assist-container">
        <ScrollReveal className="assist-section-head">
          <p className="assist-section-eyebrow">{t("benefits.badge", "Avantages")}</p>
          <h2 className="assist-section-title">
            {t("benefits.title", "Des résultats concrets dès le premier mois")}
          </h2>
        </ScrollReveal>

        <div className="assist-benefits-grid">
          {benefits.map((b, i) => (
            <ScrollReveal key={b.titleKey} delay={i * 80}>
              <article className="assist-card assist-benefit-card">
                <div className="assist-benefit-top">
                  <div className="assist-feature-icon">
                    <b.icon className="assist-icon" />
                  </div>
                  <div>
                    <span className="assist-benefit-stat">{b.stat}</span>
                    <span className="assist-benefit-label">{t(b.statLabelKey, b.statLabel)}</span>
                  </div>
                </div>
                <h3 className="assist-feature-title">{t(b.titleKey, b.title)}</h3>
                <p className="assist-feature-text">{t(b.descKey, b.description)}</p>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;